// React
import React from 'react';
import CybsCombobox from '../combobox/component';

const CybsSelect = React.forwardRef((props, ref) => {
  const { dataTest } = props;

  return (
    <CybsCombobox
      {...props}
      ref={ref}
      dataTest={`${dataTest}-cybsSelect`}
      type="single"
      selectBehavior
    />
  );
});

CybsSelect.propTypes = { ...CybsCombobox.propTypes };
CybsSelect.defaultProps = { ...CybsCombobox.defaultProps };
CybsSelect.displayName = 'CybsSelect';

export default CybsSelect;
